var verbCategoryList = [{
  value: 1,
  label: '个人成就'
}, {
  value: 2,
  label: '教学和指导'
}, {
  value: 3,
  label: '行政和综合事务'
}, {
  value: 4,
  label: '领导能力'
}, {
  value: 5,
  label: '人际沟通能力'
}, {
  value: 6,
  label: '组织计划能力'
}, {
  value: 7,
  label: '创造创新能力'
}, {
  value: 8,
  label: '研究分析能力'
}, {
  value: 9,
  label: '金融和财经'
}, {
  value: 10,
  label: '技术能力'
}];

var verbTextList = [{
  categoryId: 1,
  children: [
    '加快',
    '实现',
    '取得',
    '启动、发起',
    '获得',
    '完成',
    '得到、赢得',
    '影响',
    '导致',
    '执行',
    '行使',
    '扩大、拓展',
    '加速、派遣',
    '产出',
    '改善、改进',
    '增加',
    '确保',
    '上市、营销',
    '掌握',
    '获得',
    '生产',
    '减少',
    '重组',
    '重塑',
    '重构',
    '简化',
    '出售',
    '争取',
    '改进',
    '成功',
    '升级'
  ]
}, {
  categoryId: 2,
  children: [
    '建议',
    '阐明、说明',
    '培训',
    '合作',
    '提供咨询',
    '担任顾问',
    '教导、教育',
    '解释',
    '促进',
    '引导、指引',
    '帮助',
    '指导',
    '建模',
    '参加',
    '辅导、教授',
    '教授',
    '训练',
  ]
}, {
  categoryId: 3,
  children: [
    '安排',
    '优化、配置',
    '制图',
    '汇总比较',
    '协调',
    '收集',
    '提供',
    '分配',
    '建立',
    '执行、完成',
    '贯彻、实现',
    '设立、任命',
    '维护',
    '提出、提供',
    '（要点）概述',
    '表现、完成任务',
    '准备',
    '处理、审阅',
    '供应',
    '购买、采购',
    '记录',
    '提交、汇报',
    '支持、辅助',
    '提供服务',
    '售后、维修',
    '来源',
  ]
}, {
  categoryId: 4,
  children: [
    '获得',
    '管理',
    '批准、核准',
    '分配',
    '签合同',
    '担任主席',
    '管控',
    '决定',
    '委派为代表',
    '指导',
    '招募',
    '管理',
    '处理',
    '创立、制定',
    '面试',
    '领导',
    '鼓励、激发',
    '命名',
    '主持',
    '招聘',
    '保持',
    '回顾、审阅',
    '挑选',
    '构想、塑造',
    '监管、督导',
    '联合',

  ]
}, {
  categoryId: 5,
  children: [
    '致辞、反馈',
    '仲裁、公断',
    '清晰阐明',
    '摘要、简报',
    '沟通',
    '执行',
    '接触、联系',
    '传达',
    '通信',
    '发表、传达',
    '证明、演示',
    '编辑、校订',
    '款待、招待',
    '通知',
    '讲授',
    '调解、调停',
    '谈判',
    '说服',
    '展示、介绍',
    '推广、提拔',
    '提出',
    '发布、出版',
    '宣传',
    '报告',
    '（担任）代表',
    '反馈',
    '建议',
    '翻译',
    '写作',
  ]
}, {
  categoryId: 6,
  children: [
    '分配',
    '预测',
    '筹备',
    '归类',
    '分类',
    '收集',
    '提炼',
    '召集',
    '分组',
    '编辑、校订',
    '消除、排除',
    '使用',
    '汇总',
    '划分',
    '监督',
    '组织',
    '计划',
    '管理',
    '安排（日程）',
    '构建',
    '总结',
  ]
}, {
  categoryId: 7,
  children: [
    '编写',
    '改变',
    '构想',
    '构造、创立',
    '创造',
    '发展、开发',
    '设计、创造',
    '起草',
    '建立',
    '构想、规划',
    '成立',
    '举例说明',
    '影响',
    '介绍、引进',
    '发明',
    '发起、发行',
    '发明',
    '改造、翻新',
    '修订',
    '筹备、举行',
    '升级',
    '形象化',
  ]
}, {
  categoryId: 8,
  children: [
    '评估',
    '比较',
    '批评、评价',
    '定义',
    '推导、得出',
    '检测出',
    '查明、确定',
    '发现',
    '评价',
    '检查',
    '开发、探究',
    '创立、创办',
    '检查',
    '解读',
    '定位',
    '测量',
    '观察',
    '预测',
    '评定、估价',
    '推荐',
    '研究、调查',
    '回顾、审阅',
    '调查',
    '搜集',
    '学习',
    '核实',
  ]
}, {
  categoryId: 9,
  children: [
    '分配、指派',
    '分析',
    '评估',
    '审计',
    '平衡',
    '做预算',
    '计算',
    '编辑、整合',
    '推算',
    '管控',
    '支付',
    '演算',
    '提供经费、筹资',
    '预测',
    '设计、计划',
    '和解',
    '制表',
  ]
}, {
  categoryId: 10,
  children: [
    '改造、适配',
    '调整',
    '应用',
    '建立',
    '计算',
    '搭建',
    '设计、策划',
    '诊断',
    '工程',
    '试验',
    '维护',
    '改进、调整',
    '操作',
    '指示',
    '编程',
    '证明',
    '加强',
    '修理、修补',
    '处理',
    '修复、重建',
    '解决',
    '详细说明',
    '系统化',
    '测试'
  ]
}];

export {
  verbCategoryList,
  verbTextList
};